// config
import { config } from '@shakkerai/config';

// client
import { getOssClient } from './get-oss-client.js';

/**
 * copyObjectToTmp
 * @param {*} url
 * @returns
 */
export const copyObjectToTmp = async (url, bizCode, destPath) => {
  const methodName = 'copyObjectToTmp';
  try {
    return await copy(url, true, bizCode, destPath);
  } catch (error) {
    console.error(methodName, 'error');
    console.error(methodName, error);
  }
};

/**
 * copyObjectToOnline
 * @param {*} url
 * @returns
 */
export const copyObjectToOnline = async (url, bizCode, destPath) => {
  const methodName = 'copyObjectToOnline';
  try {
    return await copy(url, false, bizCode, destPath);
  } catch (error) {
    console.error(methodName, 'error');
    console.error(methodName, error);
  }
};

// copy
async function copy(srcUrl, toTemp, bizCode, destPath) {
  const methodName = 'copys';
  try {
    // log
    console.info(methodName, 'srcUrl', srcUrl);

    // check
    if (!srcUrl) {
      console.info(methodName, 'need srcUrl');
      return;
    }

    // client
    // 0生图，模版工具，专业工具，1社区，2训练
    bizCode = bizCode || '0';

    const client = await getOssClient(bizCode, toTemp);
    if (!client) return;

    // const
    const fromHost = toTemp ? config.oss.cdnHost : config.oss.cdnHostForSDTmp;
    const fromBucket = toTemp ? config.oss.ossBucket : config.oss.ossBucketForSDTmp;
    const toHost = toTemp ? config.oss.cdnHostForSDTmp : config.oss.cdnHost;
    console.info(methodName, 'fromHost', fromHost);
    console.info(methodName, 'fromBucket', fromBucket);
    console.info(methodName, 'toHost', toHost);

    // filename
    const urls = srcUrl.split(`${fromHost}/`);
    const srcFilename = urls[urls.length - 1];
    const destFilename = `copy/${destPath || srcFilename}`;

    console.info(methodName, 'srcFilename', srcFilename);
    console.info(methodName, 'destFilename', destFilename);

    const res = await client.copy(destFilename, srcFilename, fromBucket);
    console.info(methodName, 'res', res);
    if (!res || !res.res || res.res.status !== 200) {
      console.error(methodName, 'copy failed');
      return;
    }

    const obj = { file: destFilename, url: `${toHost}/${destFilename}` };
    console.info(methodName, 'obj', obj);
    return obj;
  } catch (error) {
    console.error(methodName, 'error');
    console.error(methodName, error);
  }
}
